/**
 * Active filter labels above the collection grid (mobile). Each label is a plain link to the
 * filtered URL; with the theme's filter form on the page, unchecking the matching input (or
 * clicking its clear link) instead lets the theme refresh the section without a page load.
 */
export function initActiveFilters() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.bx-active-filters a');
    if (!link) return;
    const form = document.getElementById('filter');
    if (!form) return;

    const clear = link.dataset.bxFilterClear;
    if (clear) {
      const target = form.querySelector(clear === 'all' ? 'a.remove-all' : 'a.clear-range');
      if (!target) return;
      event.preventDefault();
      target.click();
      return;
    }

    const input = document.getElementById(link.dataset.bxFilterInput);
    if (!input || !form.contains(input) || !input.checked) return;
    event.preventDefault();
    input.checked = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
